import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, { class: "account-settings-section" }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("header", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
          (_ctx.open)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 0,
                type: "button",
                class: "button--white",
                onClick: _ctx.toggle
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseSvg, { icon: "account/x" })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.open && _ctx.isEditable)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 1,
                type: "button",
                class: "button--white",
                onClick: _ctx.toggle
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Edit")
                ])),
                _: 1,
                __: [1]
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default", { open: _ctx.open }, undefined, true),
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("footer", _hoisted_1, [
              (_ctx.open)
                ? (_openBlock(), _createBlock(_component_BaseButton, {
                    key: 0,
                    type: "button",
                    class: "button--white",
                    onClick: _ctx.toggle
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Cancel")
                    ])),
                    _: 1,
                    __: [2]
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_BaseButton, {
                loading: _ctx.loading,
                type: "submit"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Save")
                ])),
                _: 1,
                __: [3]
              }, 8, ["loading"])
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 3
  }))
}